import { PanelTitle } from './ui/MetricPanel';
import { Link } from 'react-router-dom';
import type { ResearchOverview } from '../api/research';
import { phaseLabel } from '../api/research';
import { fmtKst, fmtPct } from '../lib/format';
import { StatusChip } from './ui/Primitives';
export default function ResearchMonitor({ data, failed = false }: {
    data: ResearchOverview | null;
    failed?: boolean;
}) {
    const forward = data?.forward;
    const rows = [
        ...(forward?.variants ?? []).map(v => ({
            id: v.id, title: v.title, status: forward!.status, result: v.return_pct,
            cost: v.cost2x_return_pct, mdd: v.mdd_pct,
            sample: `관측 ${v.marks} · 조정 ${v.rebalances} · 열린 ${v.open_positions}`,
            at: v.last_observed_at, end: forward?.finalize_after ?? forward?.end,
            basis: '독립 가상 NAV · 비용·펀딩 포함', error: v.failure_count ? `실패 ${v.failure_count}건` : forward?.error,
            href: '/research/forward',
        })),
        ...(data?.shadows ?? []).flatMap(s => (s.metrics?.length ? s.metrics : [{
                id: s.id, title: s.title, return_pct: null, cost2x_return_pct: null,
                mdd_pct: null, closed_trades: null, open_positions: null, basis: '성과 미관측', cost_basis: '',
            }]).map(m => ({
            id: `${s.id}:${m.id}`, title: `${s.title} · ${m.id === s.id ? '' : m.id}`,
            status: s.status, result: m.return_pct, cost: m.cost2x_return_pct, mdd: m.mdd_pct,
            sample: `완료 ${m.closed_trades ?? '—'} · 열린 ${m.open_positions ?? '—'}`,
            at: s.observed_until, end: s.end, basis: m.basis,
            error: s.error ?? (s.report_stale ? '저장 보고 갱신 필요' : null),
            href: `/research/forward#${s.id}`,
        }))),
    ];
    return <section className="card" id="research-monitor" aria-label="연구 현황">
    <div className="card-title-row"><PanelTitle>독립 연구 · 현재 성과와 관측 근거</PanelTitle><Link className="research-link" to="/research/forward">연구 상세 →</Link></div>
    <p className="muted-note">가상 관찰·저장 보고 · C1 자산에 합산하지 않음 · 자동 운용 승격 없음{failed ? ' · 최근 조회 실패, 마지막 자료 표시' : ''}</p>
    {!data && <p>연구 근거 조회 중</p>}
    <div className="research-monitor-list">
      {rows.map(r => <article className="research-monitor-row" key={r.id}>
        <div className="research-monitor-name"><Link to={r.href}>{r.title}</Link>
          <StatusChip tone={failed || ['unavailable', 'blocked'].includes(r.status) ? 'warn' : 'info'}>{phaseLabel[r.status] ?? '확인 필요'}</StatusChip>
          <p className="muted-note">{r.basis}</p>{r.error && <p className="research-alert">{r.error}</p>}
        </div>
        <dl className="monitor-facts">
          <div><dt>관측 수익</dt><dd>{fmtPct(r.result, { sign: true })}</dd></div>
          <div><dt>비용 2배</dt><dd>{fmtPct(r.cost, { sign: true })}</dd></div>
          <div><dt>MDD</dt><dd>{fmtPct(r.mdd)}</dd></div>
          <div><dt>표본·포지션</dt><dd>{r.sample}</dd></div>
          <div><dt>최근 실제 관측 · KST</dt><dd>{fmtKst(r.at, { seconds: false })}</dd></div>
          <div><dt>판정·감사 · KST</dt><dd>{fmtKst(r.end, { seconds: false })}</dd></div>
        </dl>
      </article>)}
    </div>
    <p className="muted-note">최근 조회 {fmtKst(data?.as_of)} KST · 미관측 비용·낙폭은 — · 거래별 복리와 가상 NAV의 계산 근거를 구분합니다.</p>
  </section>;
}
